export const LOCATION_TYPE_LOCATIONS = 'LOCATIONS';
export const LOCATIONS_VIEW = 'locations_view';
export const LOCATIONS_CREATE = 'locations_create';
export const LOCATIONS_EDIT = 'locations_edit';
export const ASSET_LOCATIONS = 'locations';
